import { render, staticRenderFns } from "./host-text-editor.vue?vue&type=template&id=39a204d4&"
import script from "./host-text-editor.vue?vue&type=script&lang=js&"
export * from "./host-text-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a204d4')) {
      api.createRecord('39a204d4', component.options)
    } else {
      api.reload('39a204d4', component.options)
    }
    module.hot.accept("./host-text-editor.vue?vue&type=template&id=39a204d4&", function () {
      api.rerender('39a204d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/host-text-editor.vue"
export default component.exports